import { TicketAllocation } from '@app-types/ticketSales';

export const MANUAL_SALES_EDITABLE_COMPANIES = new Set(['AXS', 'The Lowry']);

export function isManualSalesEditable(row: TicketAllocation): boolean {
  return MANUAL_SALES_EDITABLE_COMPANIES.has(row.ticketCompany);
}

export function sortAllocations<T extends { ticketCompany: string; ticketName: string }>(allocations: T[]): T[] {
  return [...allocations].sort((a, b) => {
    const byCompany = a.ticketCompany.localeCompare(b.ticketCompany);
    return byCompany !== 0 ? byCompany : a.ticketName.localeCompare(b.ticketName);
  });
}

// TODO: resolve this calculations with actual Calculator
export function withRecalculatedSales(row: TicketAllocation, manualSales: number): TicketAllocation {
  const feedSales = row.feedSales ?? 0;
  const totalSales = feedSales + manualSales;
  const percentSold = row.allocation > 0 ? Math.round((totalSales / row.allocation) * 100) : 0;

  return {
    ...row,
    manualSales,
    totalSales,
    percentSold,
    unsold: row.allocation - totalSales,
  };
}

// TODO: resolve this calculations with actual summary Calculator
export function sumAllocationTotals(rows: TicketAllocation[]) {
  return rows.reduce(
    (totals, row) => ({
      allocation: totals.allocation + row.allocation,
      feedSales: totals.feedSales + (row.feedSales ?? 0),
      manualSales: totals.manualSales + row.manualSales,
      totalSales: totals.totalSales + row.totalSales,
      unsold: totals.unsold + row.unsold,
    }),
    {
      allocation: 0,
      feedSales: 0,
      manualSales: 0,
      totalSales: 0,
      unsold: 0,
    },
  );
}
